import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

/**
 * ОРДЗ.
 */

const initialState: any = 0;

export const currentPageSlice = createSlice({
  name: 'currentPage',
  initialState,
  reducers: {
    currentPage: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { currentPage } = currentPageSlice.actions;

export default currentPageSlice.reducer;
